import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService, ConfirmationService } from 'primeng/api';
import { PermissoesService } from 'src/services/permissoes.service';
import { GrupoEmailService } from 'src/services/grupo-email.service';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { EstacaoService } from 'src/services/estacao.service';
import { PessoaService } from 'src/services/pessoa.service';

@Component({
    selector: 'app-grupo-email',
    templateUrl: './grupo-email.component.html',
    styleUrls: ['./grupo-email.component.scss'],
    standalone: false
})
export class GrupoEmailComponent implements OnInit, AfterViewInit {
    data: any[] = [];
    form: FormGroup;
    displayModal: boolean = false;
    loading: boolean = false;

    dropDownClientes: any[] = [];
    dropDownEstacoes: any[] = [];

    novoEmail: string = '';
    emailsAdicionados: any[] = [];
    emailsSelecionados: any[] = [];

    pessoaClienteId: number | null = null;
    estacoesSelecionadas: number[] = [];

    user: any = {};
    empresas: any[] = [];

    private clienteSubscription: Subscription;
    @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
    scrollHeight: string = '600px'; // Valor inicial maior para garantir renderização

    constructor(
        protected _formBuilder: FormBuilder,
        protected grupoEmailService: GrupoEmailService,
        protected permissaoService: PermissoesService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        protected _estacaoService: EstacaoService,
        protected _pessoaService: PessoaService
    ) {}

    ngOnInit(): void {
        this.user = JSON.parse(localStorage.getItem('user') ?? '{}');
        this.empresas = JSON.parse(localStorage.getItem('empresas') ?? '[]');
        this.initializeForm();
        console.log('ngOnInit - chamando index()');
        this.index();
        this.listClientes();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.calculateScrollHeight();
        }, 200);
    }

    calculateScrollHeight(): void {
        if (this.tableWrapper && this.tableWrapper.nativeElement) {
            const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
            // Subtrai apenas altura do caption (~60px) e paginator (~60px), header já está dentro do scrollable
            const calculatedHeight = wrapperHeight - 120;
            this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
        } else {
            // Se o wrapper ainda não estiver disponível, tenta novamente
            setTimeout(() => {
                this.calculateScrollHeight();
            }, 100);
        }
    }

    get isUsuarioInterno(): boolean {
        return this.user?.usuario_interno === true;
    }

    initializeForm(): void {
        this.form = this._formBuilder.group({
            id: [null],
            descricao: [null, Validators.required],
            grupo_interno: [true],
            ativo: [true],
            emails: [[], Validators.required],
            pessoa_cliente_id: [null],
            estacoes: [[]],
            diasemana_dom: [false],
            diasemana_seg: [false],
            diasemana_ter: [false],
            diasemana_qua: [false],
            diasemana_qui: [false],
            diasemana_sex: [false],
            diasemana_sab: [false],
            horario: [null],
        });
        
        // Configurar estado inicial dos controles disabled
        this.updateDisabledState();
    }
    
    updateDisabledState(): void {
        const grupoInternoControl = this.form.get('grupo_interno');
        const pessoaClienteControl = this.form.get('pessoa_cliente_id');
        const shouldDisableGrupoInterno = !this.isUsuarioInterno && !this.form.get('id')?.value;
        
        if (shouldDisableGrupoInterno) {
            grupoInternoControl?.disable();
        } else {
            grupoInternoControl?.enable();
        }
        
        if (shouldDisableGrupoInterno) {
            pessoaClienteControl?.disable();
        } else {
            pessoaClienteControl?.enable();
        }
    }

    onTipoGrupoChange(): void {
        const isInterno = this.form.get('grupo_interno').value;
        const pessoaControl = this.form.get('pessoa_cliente_id');
        const estacoesControl = this.form.get('estacoes');

        if (isInterno) {
            this.pessoaClienteId = null;
            this.estacoesSelecionadas = [];
            this.form.get('pessoa_cliente_id').setValue(null);
            this.form.get('estacoes').setValue([]);
            this.form.patchValue({
                diasemana_dom: false,
                diasemana_seg: false,
                diasemana_ter: false,
                diasemana_qua: false,
                diasemana_qui: false,
                diasemana_sex: false,
                diasemana_sab: false,
                horario: null,
            });
            pessoaControl.setValidators(null);
            estacoesControl.setValidators(null);
            this.listEstacoes();
        } else {
            pessoaControl.setValidators(Validators.required);
            estacoesControl.setValidators(Validators.required);
        }

        pessoaControl.updateValueAndValidity();
        estacoesControl.updateValueAndValidity();
    }

    index(): void {
        console.log('index() chamado');
        this.loading = true;
        console.log('Chamando grupoEmailService.index()');
        this.grupoEmailService.index().subscribe({
            next: (json) => {
                console.log('Dados recebidos do serviço:', json);
                this.data = json || [];
                console.log('Data após atribuição:', this.data);
                this.loading = false;
                setTimeout(() => {
                    this.calculateScrollHeight();
                }, 200);
            },
            error: (error) => {
                console.error('Erro ao carregar grupos de email:', error);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Erro ao carregar grupos de email',
                });
                this.loading = false;
                this.data = [];
            },
        });
    }

    listClientes() {
        this.dropDownClientes = [];
        this._pessoaService.index().subscribe((json) => {
            (json || [])
                .filter((item: any) => item.ativo === true)
                .forEach((item: any) => {
                    this.dropDownClientes.push({
                        label: item.nome,
                        value: item.id,
                    });
                });
        });
    }

    listEstacoes(): void {
        this._estacaoService.lookup().subscribe((json) => {
            this.dropDownEstacoes = [
                { value: 'null', label: 'Selecione' },
                ...json.map((item) => ({
                    value: item.id,
                    label: item.descricao,
                })),
            ];
        });
    }

    isEmailValido(email: string): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    adicionarEmail(): void {
        if (this.isEmailValido(this.novoEmail)) {
            const emailExistente = this.emailsAdicionados.find(
                (e) => e.email.toLowerCase() === this.novoEmail.toLowerCase()
            );

            if (!emailExistente) {
                this.emailsAdicionados.push({
                    email: this.novoEmail,
                    ativo: true,
                });
                this.atualizarEmailsNoForm();
                this.novoEmail = '';
            } else {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Aviso',
                    detail: 'Este email já foi adicionado',
                });
            }
        }
    }

    removerEmail(email: any): void {
        this.emailsAdicionados = this.emailsAdicionados.filter(
            (e) => e !== email
        );
        this.atualizarEmailsNoForm();
    }

    onEmailSelectionChange(event: any): void {
        this.emailsSelecionados = event.value;
    }

    atualizarEmailsNoForm(): void {
        this.form.get('emails').setValue(this.emailsAdicionados);
    }

    openNew(): void {
        // Se for usuário externo, grupo_interno deve ser false
        const grupoInterno = this.isUsuarioInterno ? true : false;
        // Se for usuário externo, pega a empresa do localStorage
        const empresaId = !this.isUsuarioInterno && this.empresas.length > 0 
            ? this.empresas[0].id 
            : null;

        this.form.reset({
            id: null,
            descricao: null,
            grupo_interno: grupoInterno,
            ativo: true,
            emails: [],
            pessoa_cliente_id: empresaId,
            estacoes: [],
            diasemana_dom: false,
            diasemana_seg: false,
            diasemana_ter: false,
            diasemana_qua: false,
            diasemana_qui: false,
            diasemana_sex: false,
            diasemana_sab: false,
            horario: null,
        });

        this.pessoaClienteId = empresaId;
        this.estacoesSelecionadas = [];
        this.emailsAdicionados = [];
        this.novoEmail = '';

        this.onTipoGrupoChange();
        this.listEstacoes();
        this.updateDisabledState();
        this.displayModal = true;
    }

    edit(grupo: any): void {
        this.listClientes();
        this.listEstacoes();
        this.grupoEmailService.show(grupo.id).subscribe({
            next: (json) => {
                this.form.patchValue({
                    id: json.id,
                    descricao: json.descricao,
                    grupo_interno: json.tipo === 'INTERNO',
                    ativo: json.ativo,
                    diasemana_dom: json.diasemana_dom || false,
                    diasemana_seg: json.diasemana_seg || false,
                    diasemana_ter: json.diasemana_ter || false,
                    diasemana_qua: json.diasemana_qua || false,
                    diasemana_qui: json.diasemana_qui || false,
                    diasemana_sex: json.diasemana_sex || false,
                    diasemana_sab: json.diasemana_sab || false,
                    horario: json.horario || null,
                    pessoa_cliente_id: json.cliente?.id || null,
                });

                this.pessoaClienteId = json.cliente?.id || null;
                this.estacoesSelecionadas =
                    json.estacoes?.map((e) => e.estacao_id) || [];
                this.form.get('estacoes').setValue(this.estacoesSelecionadas);

                this.emailsAdicionados =
                    json.emails?.map((email: any) => ({
                        id: email.id,
                        email: email.email,
                        ativo: email.ativo,
                    })) || [];

                this.form.get('horario').updateValueAndValidity();
                this.onTipoGrupoChange();
                this.updateDisabledState();

                this.atualizarEmailsNoForm();
                this.displayModal = true;
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Erro ao carregar grupo de email',
                });
            },
        });
    }

    save(): void {
        this.loading = true;
        const isInterno = this.form.get('grupo_interno').value;
        // 

        const horarioValue = this.form.get('horario').value;
        const horarioFormatado = horarioValue;

        const formValue = this.form.value;
        const estacoesSelecionadas = formValue.estacoes || [];
        const payload: any = {
            ...formValue,
            pessoa_cliente_id: isInterno
                ? null
                : formValue.pessoa_cliente_id ?? this.pessoaClienteId,
            emails: this.emailsAdicionados,
            estacoes: estacoesSelecionadas.map((estacaoId: number) => ({
                estacao_id: estacaoId,
                ativo: true,
            })),
        };

        if (isInterno) {
            delete payload.pessoa_cliente_id;
            delete payload.estacoes;
            delete payload.diasemana_dom;
            delete payload.diasemana_seg;
            delete payload.diasemana_ter;
            delete payload.diasemana_qua;
            delete payload.diasemana_qui;
            delete payload.diasemana_sex;
            delete payload.diasemana_sab;
            delete payload.horario;
        }

        const request = formValue.id
            ? this.grupoEmailService.update(payload, formValue.id)
            : this.grupoEmailService.store(payload);

        request.subscribe({
            next: (json) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: `Grupo de email ${
                        formValue.id ? 'atualizado' : 'criado'
                    } com sucesso`,
                });
                this.index();
                this.displayModal = false;
                this.loading = false;
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: `Erro ao ${
                        formValue.id ? 'atualizar' : 'criar'
                    } grupo de email`,
                });
                this.loading = false;
            },
        });
    }

    /**
     * Abre o diálogo de confirmação para excluir o grupo de email.
     * Documentação: DELETE /api/grupo-emails/{id} — soft delete (ativo = false). Resposta 200 com message, 404 se não encontrado.
     */
    confirmarExclusao(grupo: any): void {
        const descricao = grupo.descricao || `ID ${grupo.id}`;
        this.confirmationService.confirm({
            key: 'globalConfirm',
            message: `Deseja realmente excluir o grupo de email "${descricao}" (código ${grupo.id})?`,
            header: 'Confirmar exclusão',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sim, excluir',
            rejectLabel: 'Cancelar',
            acceptButtonStyleClass: 'p-button-danger',
            accept: () => this.excluirGrupoEmail(grupo.id),
        });
    }

    /**
     * Chama DELETE /api/grupo-emails/{id}. Em sucesso (200), remove o item da lista e exibe mensagem.
     */
    private excluirGrupoEmail(id: number): void {
        this.grupoEmailService.destroy(id).subscribe({
            next: (res: any) => {
                this.data = this.data.filter((item: any) => item.id !== id);
                this.messageService.add({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: res?.message || 'Grupo de email desativado com sucesso.',
                });
                setTimeout(() => this.calculateScrollHeight(), 200);
            },
            error: (err) => {
                const status = err?.status;
                const msg = err?.error?.message || err?.error?.error;
                if (status === 404) {
                    this.data = this.data.filter((item: any) => item.id !== id);
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Atenção',
                        detail: msg || 'Grupo de email não encontrado. Removido da lista.',
                    });
                } else {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: msg || 'Não foi possível excluir o grupo de email.',
                    });
                }
            },
        });
    }

    ngOnDestroy(): void {
        if (this.clienteSubscription) {
            this.clienteSubscription.unsubscribe();
        }
    }
}
